import { render, staticRenderFns } from "./education_feed_edit_modal.vue?vue&type=template&id=349526be&scoped=true"
import script from "./education_feed_edit_modal.vue?vue&type=script&lang=js"
export * from "./education_feed_edit_modal.vue?vue&type=script&lang=js"
import style0 from "./education_feed_edit_modal.vue?vue&type=style&index=0&id=349526be&prod&scoped=true&lang=css"
import style1 from "./education_feed_edit_modal.vue?vue&type=style&index=1&id=349526be&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349526be",
  null
  
)

export default component.exports